import Container from 'react-bootstrap/Container'
import UserMenuBar from '../UserMenuBar/UserMenuBar'

import { useShowHeader } from 'components/Header/hooks/useShowHeader'
import './DesktopMenuBar.scss'

const DesktopMenuBar = ({
    loading,
    logout,
    isClubMember,
    ticketsRef,
    cinestarClubRef,
    lostCardRef,
    contactInfoRef,
    changePassRef,
    isSticky,
}) => {
    const color = isClubMember ? 'purple' : 'blue'
    const { isVisible } = useShowHeader(false)

    return (
        <Container fluid className={`desktop-menu-bar`}>
            <UserMenuBar
                logout={logout}
                loading={loading}
                isClubMember={isClubMember}
                ticketsRef={ticketsRef}
                cinestarClubRef={cinestarClubRef}
                lostCardRef={lostCardRef}
                contactInfoRef={contactInfoRef}
                changePassRef={changePassRef}
                color={color}
                className={isSticky && `${isVisible ? 'fixed-on-top-moved' : 'fixed-on-top'}`}
                isSticky={isSticky}
            />
        </Container>
    )
}

export default DesktopMenuBar
